import type { SVGProps } from 'react';
const SvgBallot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#ballot_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13 9.5h5v-2h-5v2Zm0 7h5v-2h-5v2Zm6 4.5H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2ZM6 11h5V6H6v5Zm1-4h3v3H7V7ZM6 18h5v-5H6v5Zm1-4h3v3H7v-3Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="ballot_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBallot;
